import React, { FC, useState, useEffect } from "react";
import {
  FormControl,
  Checkbox,
  ListItemText,
  Grid,
  InputLabel,

} from "@mui/material";
import useStyles from "../../../components/common/model/styles";
import { FormFieldProps } from "../../../utils/formFields";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MultipleSelectNative: FC<FormFieldProps> = (props) => {
  const classes = useStyles();
  const [selectedValues, setSelectedValues] = useState<string[]>(props.selectedValues || []);

  useEffect(() => {
   
    setSelectedValues(props.selectedValues || []);
  }, [props.selectedValues]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>, name: string) => {
    const checked = event.target.checked;
    let newSelected: string[] = [];

    if (checked) {
      newSelected = [...selectedValues, name];
    } else {
      newSelected = selectedValues.filter((value) => value !== name);
    }

    setSelectedValues(newSelected);

    if (props.onChange) {
      props.onChange({ target: { id: props.id, value: newSelected.length ? newSelected : ""  } });
    }
  };

const isCheckboxDisabled = (name: string) => {
  const filteredValues = selectedValues.filter(val => val.trim() !== '');
  const currentRole = name.toLowerCase();
  const lowerSelected = filteredValues.map(role => role.toLowerCase());

  // ✅ Always disable "Owner"
  // if (!lowerSelected.includes('owner') && !lowerSelected.includes('TENANT') && currentRole === 'owner') return true;
  
  if (filteredValues.includes(name)) return false;

  // Nothing selected → all enabled
  if (filteredValues.length === 0) return false;

  // Max 2 roles allowed
  if (filteredValues.length >= 2) return true;

  const isSurveyorSelected = lowerSelected.includes('surveyor');

  if (isSurveyorSelected) {
    // If Surveyor selected, allow only Admin or others except Tenant/Owner
    const disallowed = ['tenant', 'owner'];
    return !(currentRole === 'admin' || (!disallowed.includes(currentRole) && currentRole !== 'surveyor'));
  }

  const isAdminOwnerTenantSelected = lowerSelected.some(role =>
    ['admin', 'owner', 'tenant'].includes(role)
  );

  if (isAdminOwnerTenantSelected) {
    // If Admin/Owner/Tenant selected, allow only Surveyor
    return currentRole !== 'surveyor';
  }

  return false;
};


  return (
    <>
      {props.label ? (
        <>
          <Grid item xs={12} sm={props?.firstColmd || 5} className={classes.labelBox}>
            <InputLabel
              sx={{ color: "#333333", fontWeight: 600, fontSize: "18px" }}
              shrink
              htmlFor={props.id}
            >
              {props.label}
              {props.isRequired && (
                <span style={{ color: "red", fontWeight: 500 }}>*</span>
              )}
            </InputLabel>
          </Grid>
          <Grid item xs={12} sm={ props?.md || 7} style={{ padding: "0px" }}>
            <FormControl
              fullWidth
              sx={{
                mt: 2,
                mb: 1,
                "& .MuiOutlinedInput-root": {
                  border: "1px solid #c4c4c4",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                overflow: 'auto',
                border: props.error ? "1px solid #d32f2f" : undefined,
              }}
              error={Boolean(props.error)}
              size="small"
            >
              <div style={{ display: 'flex', flexDirection: props?.flexDirection || 'column', background: "#fff" }}>
                {props?.options?.map((name: string) => (
                  <label key={name} style={{ display: 'flex', alignItems: 'center', textTransform:'capitalize' }}>
                    <Checkbox  
                      checked={selectedValues.includes(name)}
                      onChange={(event:any) => handleChange(event, name)}
                      disabled={isCheckboxDisabled(name)}
                      sx={{  color: '#02906F',
                        '&.Mui-checked': {
                          color: '#02906F',
                        },}}
                    />
                    <ListItemText  primary={name} className="listItem"/>
                  </label>
                ))}
              </div>
            </FormControl>
          </Grid>
        </>
      ) : (
        <FormControl
          fullWidth
          sx={{
            mt: 2,
            mb: 1,
            "& .MuiOutlinedInput-root": {
              border: "1px solid #c4c4c4",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            overflow: 'auto',
          }}
          error={Boolean(props.error)}
          size="small"
        >
          <div style={{ display: 'flex', flexDirection: 'column', background: "#fff" }}>
            {props?.options?.map((name: string) => (
              <label key={name} style={{ display: 'flex', alignItems: 'center' }}>
                <Checkbox
                  checked={selectedValues.includes(name)}
                  onChange={(event) => handleChange(event, name)}
                  sx={{  color: '#02906F',
                    '&.Mui-checked': {
                      color: '#02906F',
                    },}}
                />
                <ListItemText className="listItem" primary={name} />
              </label>
            ))}
          </div>
        </FormControl>
      )}
    </>
  );
};

export default MultipleSelectNative;
